import { useReveal } from "../../lib/reveal";

const steps = [
  {
    n: "01",
    title: "Briefing & conceito",
    body: "O primeiro passo da MetierCom é entender o conteúdo e formular um briefing para iniciar a busca por soluções criativas que conversem com o tema proposto.",
  },
  {
    n: "02",
    title: "Curadoria & personalização",
    body: "Selecionamos cada item, customizamos embalagem, carta de boas-vindas e materiais de apoio. Aprovação em mockup antes de produzir.",
  },
  {
    n: "03",
    title: "Manuseio & embalagem",
    body: "Desde o desenho do berço e da caixa até a embalagem de transporte a nossa atenção é total. Chegar em perfeitas condições no destino final é a nossa missão.",
  },
  {
    n: "04",
    title: "Envio & relatórios",
    body: "Despacho com rastreio, descritivo legal e cartas. Você acompanha tudo por relatório. Follow-up de satisfação, se desejar.",
  },
];

export default function Processo() {
  const { ref, visible } = useReveal();
  return (
    <section
      id="processo"
      ref={ref}
      data-testid="processo-section"
      className="py-24 md:py-32"
      style={{ backgroundColor: "#EAE7E0" }}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className={`grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 reveal ${visible ? "in" : ""}`}>
          <div className="lg:col-span-4">
            <p className="overline">Como funciona</p>
            <h2 className="font-serif font-light text-4xl md:text-5xl lg:text-6xl tracking-tight text-[#1C1C1C] mt-6 leading-[1.05]">
              O seu projeto <em className="italic text-[#556052]">conduzido</em> na ponta dos dedos.
            </h2>
            <p className="mt-6 text-base text-[#556052] font-light leading-relaxed">
              Você cuida do conteúdo. A MetierCom cuida de tudo que chega na casa do seu aluno —
              da concepção ao último relatório.
            </p>
          </div>

          <ol className="lg:col-span-8 divide-y divide-[rgba(28,28,28,0.12)]">
            {steps.map((s, i) => (
              <li
                key={s.n}
                data-testid={`processo-step-${s.n}`}
                className="grid grid-cols-12 gap-6 py-8 md:py-10 first:pt-0 group"
              >
                <div className="col-span-3 md:col-span-2">
                  <span className="font-serif text-5xl md:text-6xl text-[#C5A059] leading-none">{s.n}</span>
                </div>
                <div className="col-span-9 md:col-span-10">
                  <h3 className="font-serif text-2xl md:text-3xl text-[#1C1C1C] leading-tight">
                    {s.title}
                  </h3>
                  <p className="mt-3 text-sm md:text-base text-[#556052] font-light leading-relaxed max-w-2xl">
                    {s.body}
                  </p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}
